import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入element ui 库
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })
import 'element-ui/lib/theme-chalk/index.css';
//引入公用样式
import '../src/assets/css/index.css'
// 引入Echarts
import Echarts from "echarts";

Vue.prototype.$echarts = Echarts;
Vue.config.productionTip = false;
// 富文本插件
import VueQuillEditor from 'vue-quill-editor'
//引入插件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import axios from './utils/axios'

import VueClipboard from 'vue-clipboard2'

import JsonExcel from 'vue-json-excel'
import config from "./config";
import i18n from "./utils/i18n";
Vue.use(VueClipboard);

Vue.prototype.$axios = axios;
// Vue.prototype.fixedIp = 'http://dnn.jiusencms.com/';
// Vue.prototype.fixedIp = 'http://dnn-test.jiusencms.com/';
Vue.prototype.fixedIp = config.server_url//28号

import Ajax from 'axios';
import qs from 'qs'

Vue.prototype.$ajax = Ajax;
Vue.prototype.$qs = qs;


import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo);

Vue.use(VueQuillEditor);


Vue.component('downloadExcel', JsonExcel);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

Vue.filter('FormatDigit', (arg1) => {
  if(arg1){
    return (arg1 * 100).toFixed(2)
  }else {
    return  0
  }
})

